import PractitionerItem from './PractitionerItem';

export default PractitionerItem;
